module.exports = __webpack_public_path__ + "img/business-card.ae5db69f.svg";